import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`By constructing a water pan shared by both the refugees and host community, people could grow their own crops and vegetables. The wide variety of vegetables enveloping the water pan contributed to improving families’ meals and incomes. `}</p>
    <p>{`WFP further supported the local community with the construction of a horticulture farm as well as a water dam for both livestock and domestic use. The dam in Kang’ura village near Kalobeyei town harvested runoff water, serving more than 50,000 people and catering for close to 40,000 animals.`}</p>
    <p>{`The water pan and the dam collect enough water to sustain the population from one rainy season to the next one. Both structures are now in the hands of the community to increase the sustainability of the project.`}</p>
    <p>{`With the EU’s support, WFP also provided farmers participating in that initiative with `}<a parentName="p" {...{
        "href": "https://insight.wfp.org/failed-season-but-farmers-in-kitui-are-not-too-worried-dd72c477d82c"
      }}>{`crop insurance`}</a>{`. This has protected their investments in case of a bad harvest and has enabled them to afford quality seeds, fertilizers and new technologies.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      